// Libs
import classNames from 'classnames/bind';
import { Box, Card, CardMedia } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { checkTypeImage } from '~/utils/helper/common';
import { IDocument } from '~/utils/interface/document';
// Styles, images, icons
import styles from './FileItem.module.scss';
import { icons } from '~/assets';

type Props = {
  document: IDocument;
  onDelete?: (file: IDocument) => void;
};

const cx = classNames.bind(styles);

const FileItem = (props: Props) => {
  //#region Destructuring Props
  const { document, onDelete } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/document', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Card component={'div'} className={cx('container')}>
      <Box className={cx('action')}>
        <img
          src={icons.commonIconClose}
          alt={t('common_alt_img', { ns: 'common/base' })}
          width={16}
          height={16}
          onClick={() => document && onDelete && onDelete(document)}
        />
      </Box>

      <Box className={cx('viewImage')}>
        {checkTypeImage(document.mimetype) ? (
          <CardMedia
            component={'img'}
            alt={t('common_alt_img', { ns: 'common/base' })}
            className={cx('image')}
            image={document.url}
            onClick={() => window.open(document?.url)}
          />
        ) : (
          <CardMedia
            component={'img'}
            alt={t('common_alt_img', { ns: 'common/base' })}
            className={cx('iconDocument')}
            image={icons.documentIconDocument}
            onClick={() => window.open(document?.url)}
          />
        )}
      </Box>
    </Card>
  );
};

export default FileItem;
